import { AloBase, getDefaultAloBase } from './AloBase'
import { AloMedia, getDefaultAloMedia } from './AloMedia'
    
export interface AloPageContent extends AloBase {                
    //pctContent:string
    pctTitle:string
    pctBaseline:string
    pctSubTitle:string
    pctHat:string
    pctMetaTitle:string
    pctMetaDesc:string
    slug:string
}

export const getDefaultAloPageContent = ():AloPageContent => {
    return {  
        ...getDefaultAloBase(),        
        pctTitle:"",
        pctBaseline:"",
        pctSubTitle:"",
        pctHat:"",
        pctMetaTitle:"",
        pctMetaDesc:"",
        slug:""
    }
}

export const cleanAloPageContent = (pageContent:AloPageContent) => {
    if(!pageContent) return    
    if(!pageContent.id) delete pageContent.id
}